import { apiClient } from '@/services/ApiClient.js'

export default {
  getAdministrativeProceedingReminders(query) {
    return apiClient
      .get('administrative-proceeding-reminders', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  getAdministrativeProceedingReminder(id) {
    return apiClient
      .get('administrative-proceeding-reminders/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  assign(proceedingReminder) {
    return apiClient
      .post('administrative-proceeding-reminders/assign', proceedingReminder)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  async saveSurveyAnswers(reminderCallId, payload) {
    const response = await apiClient
      .post(`administrative-proceeding-reminders/${reminderCallId}/save-phone-survey-answers`, payload)

    return response
  }
}
